import AmbisMeter from "@/modules/ambis_meter/components/AmbisMeter";
import AmbisMeterForm from "@/modules/ambis_meter/components/AmbisMeterForm";
import AmbisMeterEditForm from "@/modules/ambis_meter/components/AmbisMeterEditForm";
import PeriodeForm from "@/modules/ambis_meter/components/PeriodeForm";
import Leaderboard from "@/modules/ambis_meter/components/Leaderboard";
import MissionForm from "@/modules/ambis_meter/components/MissionForm";
import LevelForm from "@/modules/ambis_meter/components/LevelForm";
import Info from "@/modules/ambis_meter/components/Info";
import InfoForm from "@/modules/ambis_meter/components/InfoForm";
import InfoPage from "@/modules/ambis_meter/components/InfoPage";
import Quote from "@/modules/ambis_meter/components/Quote";
import QuoteForm from "@/modules/ambis_meter/components/QuoteForm";

export default [
    {
        path: "/ambis-meter",
        name: "AmbisMeter",
        component: AmbisMeter,
    },
    {
        path: "/ambis-meter-form",
        name: "AmbisMeterForm",
        component: AmbisMeterForm,
    },
    {
        path: "/ambis-meter-edit-form",
        name: "AmbisMeterEditForm",
        component: AmbisMeterEditForm,
    },
    {
        path: "/periode-form",
        name: "PeriodeForm",
        component: PeriodeForm,
    },
    {
        path: "/mission-form",
        name: "MissionForm",
        component: MissionForm,
    },
    {
        path: "/level-form",
        name: "LevelForm",
        component: LevelForm,
    },
    {
        path: "/leaderboard",
        name: "Leaderboard",
        component: Leaderboard,
    },
    {
        path: "/quote",
        name: "Quote",
        component: Quote,
    },
    {
        path: "/quote-form",
        name: "QuoteForm",
        component: QuoteForm,
    },
    {
        path: "/info",
        name: "Info",
        component: Info,
    },
    {
        path: "/info-form",
        name: "InfoForm",
        component: InfoForm,
    },
    {
        path: "/info-page",
        name: "InfoPage",
        component: InfoPage,
    },
];



// WEBPACK FOOTER //
// ./src/modules/ambis_meter/router/ambis_meter.js